import { Link } from "react-router-dom";

import PageBanner from "../../layouts/PageBanner";
import { EducationSupport } from "../../constant/theme";

const NewLifeProgram = () => {
  return (
    <>
      <div className="page-content bg-white">
        <PageBanner maintitle="Home" pagetitle="Project" />

        <section className="content-inner bg-light section-pattren1">
          <div className="container">
            <div className="row align-items-center flex-column-reverse flex-lg-row">
              <div className="col-lg-12 align-self-center">
                <div className="section-head m-b30">
                  <h2 className="title mb-3 padding">
                    New Life Program {" "}
                  </h2>
                </div>
              </div>
            </div>

            <div className=" dz-card blog-single sidebar">
              <div>
                <div className="dz-meta">
                  <ul>
                    {/* <li className="post-date">
                      <i className="fa-solid fa-calendar-days"></i> September,
                      2025
                    </li> */}
 
                  </ul>
                </div>
                <div className="dz-post-text">
                  <div>
                    <p>
                      New Life Program (Adyar Cancer Institute)
                      <br />
                       ▪ Proposed Start Date:1-Feb-2026<br />
▪ Proposed End Date: 30-Apr-2026<br />
▪ Location: Adyar, Chennai, Tamil Nadu.
                      
                    </p>

                    {/* <div className="row mb-3">
                       <div className="col-6 d-flex flex-column">
                        <div className="mb-2">
                          <img
                            src={EducationSupport.E_support1}
                            alt=""
                            className="img-fluid"
                          />
                        </div>
                      </div>

                       <div className="col-6">
                        <img
                          src={EducationSupport.E_support2}
                          alt=""
                          className="img-fluid"
                        />
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default NewLifeProgram;
